import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/baseInformation/garageoa';
import waves from '@/directive/waves'; // 水波纹指令

import garageoaAdd from './add';
import parkingLotAdd from '../pakinglotoa/add';
import garageoaDetail from './detail';
export default {
  components: {
    garageoaAdd: garageoaAdd,
    garageoaDetail: garageoaDetail,
    parkingLotAdd: parkingLotAdd
  },
  directives: {
    waves: waves
  },
  props: ['routerIdArr', 'id', 'flagId', 'activeName', 'isInitSearch'],
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        garageName: '',
        garageAddress: ''
      },
      title: '',
      garageId: '',
      updateIdArr: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogDetailVisible: false,
      dialogParkingLotVisible: false
    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var garageIds = [];
      this.multipleSelection.forEach(function (row) {
        garageIds.push(row.garageId);
      });
      this.delete(garageIds);
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
        this.$emit('loadMenuTab');
        this.$emit('refreshTree');
      }

      this.dialogFormVisible = false;
      this.dialogParkingLotVisible = false;
    },
    handDetailCancle: function handDetailCancle(flag) {
      this.dialogDetailVisible = false;

      if (flag === 'add') {
        this.dialogParkingLotVisible = true;
        this.title = '添加';
        this.updateIdArr = JSON.parse(JSON.stringify(this.routerIdArr));
        this.updateIdArr.push(String(this.garageId));
      } else {
        this.dialogFormVisible = true;
        this.title = '编辑';
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.garageName = '';
        this.listQuery.garageAddress = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    getItemDetail: function getItemDetail(garageId) {
      this.garageId = garageId;
      this.title = '详情';
      this.dialogDetailVisible = true;
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.garageId = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(garageId) {
      this.garageId = garageId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(garageIds) {
      var _this2 = this;

      if (garageIds.length > 0) {
        this.$confirm('你确定是要删除这些车库, 是否继续?', '提示').then(function () {
          fetchDelete(garageIds).then(function (response) {
            if (response.data.code == 200) {
              _this2.getList();

              _this2.$emit("refreshTree");

              _this2.$emit("loadMenuTab");

              _this2.Alert({
                alertType: "delete"
              });
            } else {
              _this2.Alert({
                alertType: "error",
                message: response.data.message
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(garageId) {
      var garageIds = [];
      garageIds.push(garageId);
      this.delete(garageIds);
    }
  }
};